module.exports = __webpack_public_path__ + "static/r2-0af134d35d3599125dca6aed6efb815b.jpg";